import { CasinoType } from 'modules/Casino/types/configuration';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IVivogamingDTO, IVivogamingGetUrl } from '../../types/interfaces/LiveCasino/VivogamingDTO';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IVivogamingDTO[]>): ISlotViewItem[] => {
    return data.map((item: IVivogamingDTO) => ({
      id: item.table_id.toString(),
      gameId: item.table_id.toString(),
      routeProvider: 'vivogaming',
      gameName: item.table_name,
      description: item.table_name,
      provider: 'vivogaming',
      type: CasinoType.liveCasino,
      imageUrl: `/images/vivogaming/${item.image}`,
      tab: [item.application.toLowerCase()],
    }));
  };

  convertGameUrl = ({ data }: IGetGameUrl<IVivogamingGetUrl, unknown>) => {
    return data;
  };
}

export default Converter;
